(function () {
    function addCloseButton(toastElement) {
      // Prevent duplicate button
      if (toastElement.querySelector(".nudgify-close-btn")) return;
  
      const closeBtn = document.createElement("button");
      closeBtn.className = "nudgify-close-btn";
      closeBtn.innerHTML = "✕";
      closeBtn.type = "button";
  
      // Ensure positioning context
      toastElement.style.position = "relative";
  
      toastElement.appendChild(closeBtn);
  
      closeBtn.addEventListener("click", function () {
        const parent = toastElement.closest(".nudgify-inline___htmlsnpt");
        if (parent) {
          parent.classList.add("close");
        }
      });
    }
  
    function checkExisting() {
      document
        .querySelectorAll(".nudgify-inline___htmlsnpt .toast-outer.outer-inline")
        .forEach(addCloseButton);
    }
  
    // Observe DOM changes
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
  
          // If the node itself matches
          if (
            node.matches &&
            node.matches(".nudgify-inline___htmlsnpt .toast-outer.outer-inline")
          ) {
            addCloseButton(node);
          }
  
          // Or if inside the node
          const innerToast = node.querySelector &&
            node.querySelector(".nudgify-inline___htmlsnpt .toast-outer.outer-inline");
  
          if (innerToast) {
            addCloseButton(innerToast);
          }
        });
      });
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  
    // Run once for already existing elements
    checkExisting();
  })();